import { render } from "./HeroBanner.vue?vue&type=template&id=63b7da1d&ts=true"
import script from "./HeroBanner.vue?vue&type=script&lang=ts"
export * from "./HeroBanner.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__